import { Navigate, Outlet } from 'react-router-dom';

import { getToken, isAdmin, isTokenExpired } from '../../utils/auth';

export default function AdminRoute() {
  const token = getToken();
  const isAuthenticated = token && !isTokenExpired(token);

  if (!isAuthenticated) {
    localStorage.removeItem('token');
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin(token)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
